import MyRecipe from "../components/Recipes/MyRecipe";

const MyRecipePage = (): JSX.Element => {
  return <MyRecipe />;
};

export default MyRecipePage;
